(() => {
  const initSizeGuide = (root) => {
    if (!root || root.dataset.rmSizeGuideReady === 'true') return;
    root.dataset.rmSizeGuideReady = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-rm-chart-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-rm-chart-panel]'));
    const unitButtons = Array.from(root.querySelectorAll('[data-rm-unit]'));
    const measurements = Array.from(root.querySelectorAll('[data-inch]'));

    const showPanel = (category) => {
      tabs.forEach((tab) => {
        const selected = tab.dataset.rmChartTab === category;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.dataset.rmChartPanel !== category;
      });
    };

    const setUnit = (unit) => {
      unitButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.rmUnit === unit));
      });
      measurements.forEach((cell) => {
        if (unit === 'cm') {
          const centimeters = Math.round(Number(cell.dataset.inch) * 2.54 * 2) / 2;
          cell.textContent = Number.isInteger(centimeters) ? String(centimeters) : centimeters.toFixed(1);
        } else {
          cell.textContent = cell.dataset.inchLabel;
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => showPanel(tab.dataset.rmChartTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[(index + offset + tabs.length) % tabs.length];
        next.focus();
        showPanel(next.dataset.rmChartTab);
      });
    });
    unitButtons.forEach((button) => button.addEventListener('click', () => setUnit(button.dataset.rmUnit)));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-rm-size-charts]').forEach(initSizeGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
